import * as React from 'react';
import {
  SimpleForm, TextInput, useNotify,
} from 'react-admin';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../redux/system/settings';
import EditToolBar from '../../../components/commons/editToolBar';
import canAccess from '../../../utils/canAccess';
import FUNC from '../../../utils/functions';

export default React.memo(() => {
  const { permissions } = useSelector((state: any) => state.app.appState);
  const canShow = canAccess(permissions, FUNC.SETTINGS);
  const canEdit = canAccess(permissions, FUNC.GENERAL_SETTING);
  const { data } = useSelector((state: any) => state.settings);
  const dispatch = useDispatch();
  const notify = useNotify();
  const onSuccess = () => {
    notify('dut.msg.save_data_success', {
      type: 'info',
    });
  };
  const transform = (val: any) => {
    const list: any[] = [];
    Object.keys(val).forEach((key) => {
      const position: { id: string, value: any } = { id: key, value: val[key] };
      list.push(position);
    });
    dispatch(actions.putOther({ list, onSuccess }));
  };
  if (!canShow) return null;
  return (
    <SimpleForm toolbar={<EditToolBar isSave={canEdit} />} onSubmit={transform}>
      <Grid container spacing={2} rowSpacing={0.5}>
        <Grid item xs={12} md={10}>
          <Grid item xs={12} md={10}>
            {data?.list?.map((e: any) => (
              <TextInput
                fullWidth
                variant="outlined"
                source={`${e.id}`}
                validate={[]}
                defaultValue={e.value}
              />
            ))}
          </Grid>
        </Grid>
      </Grid>
    </SimpleForm>
  );
});
